import { Link } from "react-router-dom";
import { ClientRegistration } from "../../../Component/Model/Dto/Advisory/ClientRegistration";
import { ILinkProps, TableColumn } from "../../../Component/Model/Table/Table";
import { Typography } from "@mui/material";

interface ClientRegistrationRows {
    clientRegistrationName: ILinkProps;
}

interface ClientRegistrationTable {
    columns: Array<TableColumn>;
    rows: Array<ClientRegistrationRows>;
}

export function ClientRegistrationsDataTableColumns(dataObject: ClientRegistration[]): ClientRegistrationTable {
    const columns = [
        {
            Header: 'Name', accessor: 'clientRegistrationName', id: 'clientRegistrationName',
            Cell: ({ value }: any) => (
                <Typography variant="caption" fontWeight="regular" color="#007bff" component={Link} to={value.linkTo}>
                    {value.itemName}
                </Typography>            
            )
        }       
    ];

    if (dataObject != undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: ClientRegistration) => ({  
            clientRegistrationId: item.clientRegistrationId,
            clientRegistrationName: { linkTo: `/advisory/clientScorecards/${item.clientRegistrationId}/${item.clientRegistrationName}`, itemName: item.clientRegistrationName},
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}

